import React from "react"
import { NavLink } from "react-router-dom"

import { PlaneIcon } from "../../../../utils/svgs"

/**
 * Navigation for read-only third-party auditor accounts. Single entry point
 * into the bookings list — no other surfaces are reachable.
 */
function AuditorNav() {
    const links = [
        {
            title: "Bookings",
            url: "bookings",
            icon: <PlaneIcon />,
        },
    ]

    return (
        <ul>
            {links.map((link) => (
                <li key={link.url}>
                    <NavLink
                        to={`/${link.url}`}
                        activeClassName="active">
                        <div className="nav-item-icon">{link.icon}</div>
                        {link.title}
                    </NavLink>
                </li>
            ))}
        </ul>
    )
}

export default AuditorNav
